import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { IslandLayoutSettingsBgImageUploader } from "./bg-image";
import { LayoutSettingsIslandContents } from "./contents";
import { IslandLayoutSettingsLanguageSwitcher } from "./language-switcher";
import { IslandLayoutSettingsLogoImage } from "./logo-image";
import { IslandLayoutSettingsSNS } from "./sns";

import type { SnackBlocksFormModelMethodsType } from "../../../../model/usecase/use-create-snack-layout-settings-form-model/methods";
import type { DesignSnackBlocksFormModel } from "../../../../model/usecase/use-create-snack-layout-settings-form-model/type";

type Props = {
	snackLayoutSettingsViewModel: DesignSnackBlocksFormModel["ViewModel"];
	snackLayoutSettingsMethods: SnackBlocksFormModelMethodsType;
};

export const IslandLayoutSettings = ({ snackLayoutSettingsViewModel, snackLayoutSettingsMethods }: Props) => {
	const islandTitle = "レイアウト設定";
	const { hotelID } = snackLayoutSettingsViewModel;

	const bgImageStyle = snackLayoutSettingsMethods.bgImageMethods.bgImage?.value
		? `url(${snackLayoutSettingsMethods.bgImageMethods.bgImage.value})`
		: "none";

	return (
		<FeatureIslandMainWithBackGround islandTitle={islandTitle}>
			<div className="mb-8 space-y-8">
				<IslandLayoutSettingsBgImageUploader bgImageMethods={snackLayoutSettingsMethods.bgImageMethods} />
				<div
					className="h-full w-full rounded-md bg-zinc-100 bg-cover bg-fixed bg-center bg-no-repeat p-2"
					style={{
						// スナック全体の背景画像
						backgroundImage: bgImageStyle,
					}}
				>
					<div className="min-h-20" />

					<IslandLayoutSettingsLogoImage logoImageMethods={snackLayoutSettingsMethods.logoImageMethods} />

					<div className="min-h-[50px]" />

					<IslandLayoutSettingsSNS SNSMethods={snackLayoutSettingsMethods.SNSMethods} />

					<div className="min-h-[106px]" />

					<LayoutSettingsIslandContents
						hotelID={hotelID}
						contentsMethods={snackLayoutSettingsMethods.contentsMethods}
					/>
				</div>
			</div>
			<IslandLayoutSettingsLanguageSwitcher
				languageSwitcherMethods={snackLayoutSettingsMethods.languageSwitcherMethods}
			/>
		</FeatureIslandMainWithBackGround>
	);
};

IslandLayoutSettings.displayName = "IslandLayoutSettings";
